import React from 'react'
import { FormControl, TextField } from '@mui/material'
import { Button } from '@mui/material'
// import contact from './contactbg.jpg'
import '../Contact/Contact.css'

export default function Contact() {

  const notification = () => {
    alert("Oops! Email was not Successfully Sent")
  }
  return (
    <>
      <div className="contact_container container my-5" style={{height:"600px"}} id='contact'>

        <div className="col-lg-5 mx-auto" >


          <div className='text-center'>
            <h4 className='my-4 contact_name'>Contact Me</h4>

            <h2 className='my-3 contact_des'>Share your ideas I'll convert them on Amazing Web Applications </h2>
            <h5 className='my-4 contact_des'>more than one year experience in this field</h5>
          </div>
          <FormControl fullWidth>
            <div className='my-2 px-2'>
              <TextField id="outlined-basic" type="text" label="Name" variant="outlined" fullWidth margin='dense' color='secondary' />

            </div>
            <div className='my-2 px-2'>
              <TextField id="outlined-basic" type="email" label="Email Address" variant="outlined" fullWidth margin='dense' color='secondary' />

            </div>
            <div className='my-2 px-2'>

              <TextField
                id="outlined-multiline-static"
                type="text"
                label="Your Message"
                multiline
                rows={4}
                fullWidth
                color='secondary'
                margin='dense'

              />

            </div>
            <div className='my-2 mx-2'>
              <Button variant="contained" color='secondary' margin='dense' onClick={notification} >SEND ME</Button>
            </div>
          </FormControl>

        </div>
      </div>



    </>
  )
}
